import React from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";
import RestartAltRoundedIcon from "@mui/icons-material/RestartAltRounded";
import "./Button.css";
import { H3SMALL } from "./Text";

const Button = ({ type, enabled }) => {
  return (
    <div enabled={enabled} className="button-navigation">
      {type === "back" && <ArrowBackIosNewRoundedIcon />}
      {type === "forward" && <ArrowBackIosNewRoundedIcon />}
      {type === "start" && <ArrowForwardIosRoundedIcon />}
      {type === "next" && <ArrowForwardIosRoundedIcon />}
      {type == "restart" && <RestartAltRoundedIcon />}
      {type == "download_800" && <H3SMALL>{"Download 800 x 480"}</H3SMALL>}
      {type == "download_1600" && <H3SMALL>{"Download 1600 x 960"}</H3SMALL>}
      {type == "share" && <H3SMALL>{"Share your flag!"}</H3SMALL>}
    </div>
  );
};

export default Button;
